// removed by extract-text-webpack-plugin
module.exports = {"Blog":"Blog__Blog__3ls5k","textArea":"Blog__textArea__2yvMU","editordiv":"Blog__editordiv__1oyDa","br_for_mobile":"Blog__br_for_mobile__3nY7A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Blog/Blog.css
// module id = 475
// module chunks = 3